require('./transactionGridTooltip.tpl.html');
require('./transactionGridTooltip.less');
const locale = require('./transactionGridTooltip.i18n.json');

/*@ngInject*/
const UITransactionGridTooltipDirective = function ($window, $document, $rootScope, $timeout, $state,
                                                    $filter, coreMediator, coreConstant, gridColumnModel, currencyUtil ) {

    let linkFunction = function ($scope, $elm, $attrs) {

        $scope.i18n = locale;
        $scope.mayCloseTooltip = true;
        $scope.xPos = -9999;
        $scope.yPos = -9999;
        $scope.tooltipWidth = 250;
        $scope.timeoutList = [];

        $scope.$on(coreConstant.event.SHOW_TRANSACTION_TOOLTIP_EVENT, function (event, showTransactionTooltipEvent) {
            gridColumnModel.setColumnPreference('system.submissionTransactionsHomePageGridColumns');
            $scope.colViewModel = gridColumnModel.getSubmissionTransactionGridColumns();
            $scope.rows = showTransactionTooltipEvent.columns;
            $scope.uri = showTransactionTooltipEvent.uri;
            let xPos = showTransactionTooltipEvent.pageX - showTransactionTooltipEvent.offsetX;
            let yPos = showTransactionTooltipEvent.pageY - showTransactionTooltipEvent.offsetY;
            showTransactionTooltipContinue(showTransactionTooltipEvent, xPos, yPos);
        });

        $scope.$on(coreConstant.event.HIDE_TRANSACTION_TOOLTIP_EVENT, function () {
            $scope.showTransactionTooltip = false;
            $scope.xPos = -9999;
            $scope.yPos = -9999;
        });

        $scope.$on('$destroy', function () {
            _.each($scope.timeoutList, function (item) {
                if (item) {
                    $timeout.cancel(item);
                }
            });
        });

        $scope.getTranslatedValueKey = function (item, column) {
            if (column.__text === 'summary') {
                if ($scope.uri.indexOf('Quote') !== -1) {
                    return _.get($scope.i18n.grid.summary, 'quote');
                } else if ($scope.uri.indexOf('Policy')) {
                    return _.get($scope.i18n.grid.summary, 'policy');
                }
                return _.get($scope.i18n.grid, column.__text);
            } else {
                return _.get($scope.i18n.grid, column.__text);
            }
        };

        $scope.getValue = function (item, column) {
            let props = [],
                value;
            props.push(column._accessor);
            value = item;

            _.each(props, function (prop) {
                if (!_.isNil(value)) {
                    value = value[prop];
                }
            });

            if(_.isUndefined(value)) {
                value = '-';
            }

            if (column._type && !_.isNil(value) && (column._type.indexOf('shortDate') >= 0 || column._type.indexOf('utcShortDate') >= 0)) {
                const filter = $filter('utcDateFilter');
                value = filter(parseInt(value), $scope.shortDateFormat);
            } else if (column._type && column._type.indexOf('currency') >= 0) {
                const filter = $filter('currency');
                let currencyFormat = currencyUtil.getCurrencyFormat(value.currencyCode);
                if(parseInt(value.total) > 0) {
                    value = filter(parseInt(value.total), currencyFormat.symbol, 0, currencyFormat.suffixSymbol, currencyFormat.customFormat);
                } else {
                    value = '-';
                }
            }
            return value;
        };

        function showTransactionTooltipContinue(event, xPos, yPos) {
            $scope.showTransactionTooltip = true;
            $scope.xPos = xPos;
            $scope.yPos = yPos;

            // transaction tooltip with right arrow
            $scope.direction = $scope.RIGHT_ARROW;
            $scope.xPos -= ($scope.tooltipWidth + 15);
            $scope.yPos -= 15;
            $scope.locationStyle = {
                'left': $scope.xPos,
                'top': $scope.yPos
            };
        }
    };

    return {
        restrict: 'AE',
        link: linkFunction,
        templateUrl: '/submissionDetailsDrawer/transactionGridTooltip/transactionGridTooltip.tpl.html'
    };
};

angular.module('gw-um-submission-grid')
    .directive('uiTransactionGridTooltip', UITransactionGridTooltipDirective);
